import { createSelector } from 'reselect';
import selectCart from './selectCart';

export default createSelector(
    selectCart,
    (state, id) => id,
    ({ cart_items: cartItems }, id) => cartItems.find(
        ({ order_detail_id: orderDetailId }) => orderDetailId === id,
    ) || null,
);
